<template>
  <section class="ctn">
    <header class="header">
      <router-link class="paper-action" to="/sites/new"><heim-icon icon="add"></heim-icon><span>{{ $t('new') }}</span></router-link>
    </header>
    <section class="table">
      <heim-table :data="filteredSites" :columns="['id', 'name', 'hosting_date_end', 'hosting_date_start', 'enabled']" cols="8">
        <template slot="colgroup">
          <col class="one">
          <col class="two">
          <col class="three">
          <col class="four">
          <col class="five">
          <col class="six">
          <col class="seven">
          <col class="ten">
        </template>
        <template slot="thead" slot-scope="props">
          <th class="collapse"></th>
          <th class="id sortable" @click="props.sortBy('id')">#<heim-icon :icon="props.sortOrders['id'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="sortable main" @click="props.sortBy('name')">{{ $t('sites') }}<heim-icon :icon="props.sortOrders['name'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="server">{{ $t('info') }}</th>
          <th class="date tab-noShow sortable" @click="props.sortBy('hosting_date_start')">{{ $t('startDate') }} <heim-icon :icon="props.sortOrders['hosting_date_start'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="date tab-noShow sortable" @click="props.sortBy('hosting_date_end')">{{ $t('endDate') }} <heim-icon :icon="props.sortOrders['hosting_date_end'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="sortable status" @click="props.sortBy('enabled')">{{ $t('monitoring') }} <heim-icon :icon="props.sortOrders['enabled'] > 0 ? 'arrow-drop-down':'arrow-drop-up'"></heim-icon></th>
          <th class="action edit"></th>
          <th class="action activity"></th>
          <th class="action details"></th>
        </template>
        <template slot="tbody" slot-scope="{ item, index, show, openDetail, cols }">
          <tr :key="'sites-'+index">
            <td>
              <heim-icon-button
                :class="show(item)?'opened':''"
                class="icon-button"
                @click.native="openDetail(item)">
                <heim-icon icon="chevron-right"></heim-icon>
              </heim-icon-button>
            </td>
            <td class="id" data-title="#">{{item.id}}</td>
            <td data-title="Site">
              <div class="row-ctn">
                <span class="label">{{item.name}}</span>
                <div class="link"><a :href="item.url" target="_blank">{{item.url}}</a></div>
              </div>
            </td>
            <td class="server">
              <div class="row-ctn">
                <span class="label"><router-link :to="{ name: 'SiteTypesDetails', params: { id: item.Type.id }}">{{ item.Type.type }}</router-link></span>
                <div class="link"><router-link :to="{ name: 'serversDetails', params: { id: item.Server.id }}">{{ item.Server.name }}</router-link></div>
              </div>
            </td>
            <td class="tab-noShow" data-title="Date Start">
                <span v-if="item.hosting_date_start">{{ $d(new Date(item.hosting_date_start), 'short') }}</span>
                <span v-else>{{$t("na")}}</span>
            </td>
            <td class="tab-noShow" data-title="Date End">
                <span v-if="item.hosting_date_end">{{ $d(new Date(item.hosting_date_end), 'short') }}</span>
                <span v-else>{{$t("na")}}</span>
            </td>
            <td class="status" data-title="Status">
              <span class="badge" :class="item.enabled?'green':'red'">{{item.enabled? $t('enabled') : $t('disabled')}}</span>
              <span class="chip" :class="item.enabled?'green':'red'"></span>
            </td>
            <td class="edit" data-title="Edit">
              <router-link class="paper-action" :to="{ path: `/sites/${item.id}/edit` }">
                <span>{{ $t('edit') }}</span><heim-icon class="icon" icon="chevron-right"></heim-icon></router-link>
            </td>
            <td class="activity" data-title="Activity">
              <router-link class="paper-action" :to="{ path: `/sites/${item.id}/details` }">
                <heim-icon icon="timeline"></heim-icon><heim-icon class="icon" icon="chevron-right"></heim-icon></router-link>
            </td>
            <td class="details mobile-link"><router-link class="link"  :to="{ path: `/sites/${item.id}/details`}"><heim-icon icon="chevron-right"></heim-icon></router-link></td>
          </tr>
          <!-- Do not add `key` here (breaks details) -->
          <!-- eslint-disable-next-line -->
          <transition name="slide-fade" :key="'detail-'+index">
            <tr v-if="show(item)" class="detail" :data-detail="item.id">
              <td class="detail-row" :colspan="cols">
                <div class="detail-container">
                  <div class="row">
                    <div class="item">
                      <span class="label">{{ $t('referenceTime') }}</span>
                      <div>{{ item.reference_time?item.reference_time/1000 + 's':'n/a' }}</div>
                    </div>
                    <div class="item">
                      <span class="label">{{ $t('beforeNotification') }}</span>
                      <div>{{ item.nb_occurence }} {{ $t('occurences') }}</div>
                    </div>
                    <div class="item">
                      <span class="label">{{ $t('pingInterval') }}</span>
                      <div>{{ item.interval/1000 }}s</div>
                    </div>
                    <div class="item">
                      <span class="label">{{ $t('server') }}</span>
                      <div>
                        <router-link :to="{ name: 'serversDetails', params: { id: item.Server.id }}">{{ item.Server.name }}</router-link>
                      </div>
                    </div>
                    <div class="item">
                      <span class="label">{{ $t('type') }}</span>
                      <div>
                        <router-link to="#">{{ item.Type.type }}</router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </transition>
        </template>
      </heim-table>
    </section>
  </section>
</template>

<script>
import HeimIcon from "@/components/icon/heim-icon.vue";
import HeimIconButton from "@/components/form/button/heim-icon-button.vue";
import HeimTable from "@/components/layout/list/heim-table.vue";
import { mapState } from "vuex";
import fuseMixin from "@/mixins/fuse";
export default {
  name: "Sites",
  components: {
    HeimIcon,
    HeimIconButton,
    HeimTable
  },
  mixins: [fuseMixin],
  mounted() {
    this.$store.dispatch("getSites");
    // we need to setup fuse inside a watcher
    // because otherwise fuse setups itselfs
    // with an empty array (no data has arrived yet)
    this.$watch(
      vm => vm.sites,
      val => {
        this.setupSites();
      }
    );
    this.setupSites();

    this.$store.dispatch("setTitle", "Sites");
  },
  computed: {
    ...mapState(["search"]),
    ...mapState({ sites: state => state.sitesState.sites })
  },
  methods: {}
};
</script>

<style scoped>
col.one { width: 8%; }
col.two { width: 10%; }
col.three { width: 15%; }
col.four { width: 20%; }
col.five { width: 20%; }
col.six { width: 20%; }
col.seven { width: 8%; }
col.eight { width: 1%; }
col.nine { width: 1%; }
col.ten { width: 1%; }
</style>
